import { Component, Input } from '@angular/core';

@Component({
  selector: 'unicon-probability-chip',
  templateUrl: './probability-chip.component.html',
})
export class ProbabilityChipComponent {
  @Input() text: string = 'Probabilidad de Cierre';
  @Input() closingProbability!: boolean;

  protected getPriorityText(closingProbability: boolean): string {
    const priorityText: Record<number, string> = {
      [1]: 'Baja',
      [2]: 'Muy Alta',
    };

    return closingProbability ? priorityText[2] : priorityText[1];
  }
}
